import DashboardInfo from './DashboardInfo';

export default DashboardInfo;
